import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M19.5 9.5H14C13.1716 9.5 12.5 8.82843 12.5 8V2.5M19.5 9.5V9.12132C19.5 8.7235 19.342 8.34196 19.0607 8.06066L13.9393 2.93934C13.658 2.65804 13.2765 2.5 12.8787 2.5H12.5M19.5 9.5V11.5M12.5 2.5H7.5C5.84315 2.5 4.5 3.84315 4.5 5.5V18.5C4.5 20.1569 5.84315 21.5 7.5 21.5H11.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1.5"
        />
        <path
            d="M18.5 14.5L21 17M21 17L18.5 19.5M21 17H14.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
        />
    </svg>
);

export default Icon;
